<div
  [class]="
    seminarCard.isCanceled
      ? 'seminar-card-element-canceled'
      : 'seminar-card-element'
  ">
  @if (seminarCard.image) {
    <div
      class="seminar-card-image"
      [style]="{ 'background-image': 'url(' + seminarCard.image + ')' }"></div>
  } @else {
    <app-avatar
      class="seminar-card-avatar"
      size="small"
      [user]="seminarCard.lecturer"></app-avatar>
  }
  <div class="seminar-card-info">
    <div class="seminar-card-info-title">{{ seminarCard.title }}</div>
    <div class="seminar-card-info-lecturer">
      {{ getFullName(seminarCard.lecturer) }}
    </div>
    <div class="seminar-card-info-date">
      <div class="date">
        @if (seminarCard.isCanceled) {
          <span class="date-canceled">Abgesagt:</span>
        }
        {{ seminarCard.date | date: 'dd.MM.yyyy' }}
      </div>
    </div>
  </div>
</div>
